import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import * as React from 'react'
import * as ReactDom from 'react-dom'
import {PaymentWallet} from 'ospg-payment-wallet';
import {TermsContentComponent} from "../../../shared/components/terms-content/terms-content.component";
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {ModalService} from "../../../shared/services/modal.service";
import {AuthService} from "../../../shared/services/auth.service";
import { properties } from 'src/environments/properties';

declare let $: any;

function _window(): any {
    return window;
}

@Component({
    selector: 'app-update-payments',
    templateUrl: './update-payments.component.html',
    styleUrls: ['./update-payments.component.scss'],
    providers: [SubscriptionService]
})
export class UpdatePaymentsComponent implements OnInit {

    userInfo: any;
    public enableCheckbox: Boolean = false;
    public displayCheckbox: Boolean = false;
    clickedOnce: Boolean = false;
    currentEnvironment: any;
    tenderInfo: any;
    isServiceError = false;
    backToManage = false;
    properties = properties;
    API_FAIL_ERROR_MESSAGE = properties.updatePayments.API_FAIL_ERROR_MESSAGE
    loading: Boolean = false;
    isB2B;

    checkboxEnable?: Function;
    isCheckboxVisible?: Function;
    routeToDashboard?: Function;
    routeToFreshPass?: Function;
    openPopUp?: Function;

    constructor(public authService: AuthService,
                public subscriptionService: SubscriptionService,
                private activeRoute: ActivatedRoute,
                private titleService: Title,
                private modalService: ModalService,
                private router: Router,) {
        this.setTitle('Freshpass - Update Payments')
    }

    ngOnInit(): void {
        if (this.activeRoute.data) {
            this.activeRoute.data.subscribe(data => {
                    let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
                    if (isSessionValid) {
                        const sessionData = {...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN']};
                        if (sessionData) {
                            this.isB2B = this.authService.checkB2B();
                            this.userInfo = sessionData;
                            this.currentEnvironment = this.subscriptionService.getEnvironment();
                            this.initSubscribes();
                            this.subscriptionService.getTenders(this.userInfo, this.currentEnvironment).subscribe((tenderData) => {
                                this.subscriptionService.loadTenders$.next(tenderData);
                            });
                        }
                    } else {
                        this.authService.redirectToSSO(data.tokenObject);
                    }
                },
                (err => {
                    this.authService.redirectToSSO({});
                }));
        }
    }

    showComponent(
        walletModule,
        paymentMethods,
        shopToken,
        checkboxEnable,
        isCheckboxVisible,
        routeToFreshPass,
        openPopUp,
        routeToDashboard) {
        ReactDom.render(React.createElement(
            PaymentWallet,
            {
                client: "FreshPass",
                paymentMethodContext: "FRESH_PASS",
                freshPassFlow: walletModule,
                paymentMethods: paymentMethods,
                shopToken: shopToken,
                checkboxEnable: checkboxEnable,
                isCheckboxVisible: isCheckboxVisible,
                routeToFreshPass: routeToFreshPass,
                openPopUp: openPopUp,
                routeToDashboard: routeToDashboard,
                ...(this.isB2B && {"customerType" : "B"})
            }
        ), document.getElementById("paymentFrame"))
    }

    initSubscribes() {
        this.subscriptionService.loadTenders$.subscribe((data) => {
            if (data !== undefined) {
                if (data !== undefined && data.paymentMethods && data.paymentMethods.length > 0) {
                    data.paymentMethods.forEach((tenderObj) => {
                        if (tenderObj.primaryPurposes.includes("DELIVERY_SUBSCRIPTION")) {
                            this.tenderInfo = tenderObj;
                        }
                    });
                }
                let checkboxEnable = (bool: Boolean) => {
                    // Based on the bool value (i.e either true/false) this method can be used to enable or disable checkbox
                    if (bool) {
                        this.backToManage = true;
                    }
                }
                let isCheckboxVisible = (bool: Boolean) => {
                    // Based on the bool value (i.e either true/false) this method can be used to make the checkbox hidden/visible
                    this.displayCheckbox = bool
                }
                let routeToDashboard = (bool: Boolean) => {
                    if (bool) {
                        this.router.navigate(['freshpass/manage']);
                    }
                }
                let routeToFreshPass = (routetoFreshpass: Boolean, tenderUpdated: Boolean) => {
                    // Based on the bool value (i.e either true/false) this method can be used to send event to freshpass for routing back to freshpass
                    if (routetoFreshpass) {
                        if (tenderUpdated) {
                            if(this.loading) {
                                return
                            }
                            this.loading = true;
                            this.currentEnvironment = this.subscriptionService.getEnvironment();
                            this.subscriptionService.reinstateSubscription(this.userInfo, this.currentEnvironment).subscribe((data) => {
                                this.isServiceError = false;
                                let temp = properties.updatePayments.paymentUpdatedMsg;
                                let tempMessage = {message: temp, isDisplayed: false};
                                let message = JSON.stringify(tempMessage);
                                localStorage.setItem('notifyMessage', message);
                                this.router.navigate(['freshpass/manage']);
                                this.loading = false;
                            }, error => {
                                this.isServiceError = true;
                                this.loading = false;
                            });
                        } else {
                            this.router.navigate(['freshpass/manage']);
                        }
                    }
                }
                let openPopUp = (event) => {
                    this.currentEnvironment = this.subscriptionService.getEnvironment();
                    this.subscriptionService.getTerms(this.userInfo, this.currentEnvironment).subscribe((data) => {
                        if (data && data.content) {
                            this.modalService.openModalWithComponent(TermsContentComponent, {
                                initialState: {
                                    userInfo: this.userInfo,
                                    content: data.content
                                },
                                class: 'slot-picker-modal',
                                backdrop: 'static',
                                ariaDescribedby: 'slot-msg',
                                ariaLabelledBy: "dialoghead-slot-details",
                            });
                        }
                    });
                }

                this.checkboxEnable = checkboxEnable;
                this.isCheckboxVisible = isCheckboxVisible;
                this.routeToDashboard = routeToDashboard;
                this.routeToFreshPass = routeToFreshPass;
                this.openPopUp = openPopUp;

                let paymentMethods = [];
                let walletModule;
                if (this.tenderInfo && this.tenderInfo.defaultAccount) {
                    paymentMethods.push(this.tenderInfo);
                    walletModule = 'edit';
                } else {
                    walletModule = 'subscription';
                }
                this.showComponent(
                    walletModule,
                    paymentMethods,
                    this.userInfo.authToken,
                    checkboxEnable,
                    isCheckboxVisible,
                    routeToFreshPass,
                    openPopUp,
                    routeToDashboard);
            }
        });
    }

    setTitle(newTitle: string): void {
        this.titleService.setTitle(newTitle);
    }

    openManageScreen() {
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        this.subscriptionService.reinstateSubscription(this.userInfo, this.currentEnvironment).subscribe((data) => {
            this.isServiceError = false;
            let temp = properties.updatePayments.paymentUpdatedMsg;
            let tempMessage = {message: temp, isDisplayed: false};
            let message = JSON.stringify(tempMessage);
            localStorage.setItem('notifyMessage', message);
            this.router.navigate(['freshpass/manage']);
        }, error => {
            this.isServiceError = true;
        });
    }
}
